
import apiClient from "../../../../http-common";
import authHeader from "../../../../authentication/authservices/auth-header";


//genericDropDown
export const genericDropDown = (searchString) => {
  return apiClient.post(`/dropdowns/itemGenericAutocomplete/${searchString}`);
};

export const purchaseUOMDropDown = () => {
  return apiClient.post(`/dropdowns/UnitOfMeasurmentDropDown`);
};

export const CompanyDropDown = () => {
  return apiClient.post(`/dropdowns/ItemCompanyDropDown`);
};

export const routeDropDown = () => {
  return apiClient.post(`/dropdowns/DrugRouteDropDown`);
};

export const doseDropDown = () => {
  return apiClient.post(`/dropdowns/DoseDropDown`);
};

export const itemTypeDropDownMaster = () => {
  return apiClient.post(`/dropdowns/ItemTypeDropDown`);
};
export const itemCategoryDropDownMaster = (Id) => {
  return apiClient.post(`/dropdowns/ItemCategoryDropDown/${Id}`);
};
//Listing API
export const itemListing = (searchObj) => {
  return apiClient.post(`/item/getList`, searchObj);
};

//Post Object API
export const postitem = (saveObj) => {
  return apiClient.post(`/item/saveOrUpdate`, saveObj);
};

// Autosearch API
export const itemSearch = (searchString) => {
  return apiClient.post(`/item/searchString/${searchString}`);
};

// FindById API
export const itemFindById = (itemId) => {
  return apiClient.get(`/item/getById/${itemId}`);
};